module.exports = __webpack_public_path__ + "static/media/grow-learn-apply.1c88a8a4.svg";